(function () {
  'use strict';

  angular
    .module('hardSoftRule')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('hardSoftRule', {
        url: '/hard-soft-rule',
        views : {
			'hardSoftRuleView' : {
				templateUrl : 'hard-soft-rule/views/hard-soft-rule.tpl.html',
				controller : 'HardSoftRuleCtrl',
				controllerAs : 'hardSoftRule'
			}
		},
      });
  }
}());
